import type { PageMeta } from '../../../lib/permissions/pageMeta'
import OnlineOrdersPage from '../../online-orders/OnlineOrdersPage'

export const pageMeta: PageMeta = {
  key: 'sell.online_orders',
  label: 'Online Orders',
  module: 'Trading',
  section: 'Sell',
  description: 'Incoming orders from the storefront',
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'edit',
    accountant: 'view', cashier: 'none', viewer: 'view',
  },
}

export default function OnlineOrdersTab() {
  return <OnlineOrdersPage />
}
